import type { ReactNode } from "react";
import { Badge, type PortalDashboardMedicareConnection } from "@dearbill/shared";
import { fmtSyncedAt } from "../dashboardFormat";
import { HomeCard } from "./HomeCard";

/**
 * The member's Blue Button connection status, which the dashboard keys on the
 * session's patient. The copy makes no claim about automatic syncing, because
 * nothing refreshes Blue Button data on a schedule.
 */
export function MedicareConnectionCard({
  connection,
}: {
  connection: PortalDashboardMedicareConnection;
}): ReactNode {
  const { connected } = connection;
  const synced = connected ? fmtSyncedAt(connection.lastSyncedAt) : null;
  return (
    <HomeCard title="Medicare Connection" titleSize="md">
      <div className="flex flex-wrap items-center gap-3">
        <Badge tone={connected ? "active" : "neutral"}>
          {connected ? "Connected" : "Not connected"}
        </Badge>
        {synced !== null && <p className="text-body-sm text-slate-teal">Last synced: {synced}</p>}
      </div>
      <p className="text-body-sm text-slate-teal">
        {connected
          ? "We use your Medicare drug coverage (Part D) information to keep your estimates up to date."
          : "Your Medicare account isn't connected to DearBill."}
      </p>
    </HomeCard>
  );
}
